import React, { useState, useEffect, useRef } from 'react';
import { Icon } from '@sumtotal/react-foundation';
import { useTranslation } from 'react-i18next';
import { NotificationsIconButton, StyledBadge } from './notificationStyles';
import {
  getUnreadNotificationCount,
  resetUnReadInAppNotificationsCount
} from '../services/notificationService';
import NotificationDrawer from './NotificationDrawer';
import useUserContext from '../../hooks/useUserContext';
import useInterval from '../../hooks/useInterval';
import authService from '../../../authentication/AuthorizeService';
import getLogger from '../../../utils/logger';
import useSettingsContext from '../../hooks/useSettingsContext';

const getSettingValueFromContext = (settingContext, settingKey) => {
  if (settingContext && settingContext.settings) {
    const settingObj = settingContext.settings.filter((setting) => setting.key === settingKey);
    return settingObj && settingObj.length > 0 ? settingObj[0].value : 5;
  }
  return null;
};

const Notifications = () => {
  const { t } = useTranslation(['TRANSLATIONS_RCORE_TOPNAV']);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const { user } = useUserContext();
  const disableNotification = user.isEmulatedUser ? false : user.mustAnswerSecurityQuestions;
  const { settingsData } = useSettingsContext();
  const [tenantKey, _setTenantKey] = useState('');
  const tenantKeyRef = useRef(tenantKey);
  const setTenantKey = (data) => {
    _setTenantKey(data);
    tenantKeyRef.current = data;
  };
  const notificationPollingFrequency = getSettingValueFromContext(
    settingsData,
    'INAPP_NOTIFICATION_POLLING_FREQUENCY'
  );
  const openNotificationDrawer = () => {
    setOpenDrawer(true);
    if (notificationCount !== 0) {
      resetUnReadInAppNotificationsCount(tenantKeyRef.current, user.personPK)
        .then((result) => {
          if (result) {
            setNotificationCount(0);
          }
          return null;
        })
        .catch((err) => {
          getLogger().error(err.response);
        });
    }
  };
  const closeNotificationDrawer = () => {
    setOpenDrawer(false);
  };

  function fetchUnreadNotificationCount(tenant) {
    getUnreadNotificationCount(tenant, user.personPK)
      .then((results) => {
        if (results) {
          setNotificationCount(results);
        }
        return null;
      })
      .catch((err) => {
        getLogger().error(err.response);
      });
  }
  useInterval(() => {
    (async () => {
      fetchUnreadNotificationCount(tenantKeyRef.current);
    })();
  }, notificationPollingFrequency * 60 * 1000);

  useEffect(() => {
    (async () => {
      const userProfile = await authService.getUserProfile();
      setTenantKey(userProfile.tenant);
      fetchUnreadNotificationCount(userProfile.tenant);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <NotificationDrawer openConfig={openDrawer} closeDrawer={closeNotificationDrawer} />
      <NotificationsIconButton
        size="small"
        label={t('RCORE_NOTIFICATIONS_LABEL')}
        disableRipple={false}
        disableFocusRipple={false}
        ariaExpanded={openDrawer}
        onClick={openNotificationDrawer}
        disabled={disableNotification}
      >
        <StyledBadge
          anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
          badgeContent={notificationCount}
        >
          <Icon iconType="MaterialIcon" iconName="NotificationsNoneOutlined" size={1.75} />
        </StyledBadge>
      </NotificationsIconButton>
    </>
  );
};

export default Notifications;
